export const linkingList = "url_list_publig";
export const pubtypeList = "pubtype_list";
export const resourceTypeList = "resource_type_list";
export const cslLocaleList = "csl_locale_list";
export const personRoleList = "person_role_list";
export const citationStyleList = "citation_styles_list";
export const initialCslLocale = "de-DE";
